module.exports = __webpack_public_path__ + "pengshows.png?08dc3eb3f0b1e849e7b6bf1a64c9ab59";